module.exports = __webpack_public_path__ + "img/apple.dcab515e.png";